export function GetText(catLang, localLabel) {
    if (catLang != 0) {
        var local = catLang.localTexts.find(localTexts => localTexts.localLabel === localLabel);
        return typeof local == "undefined" ? localLabel : local.localText;
    }
}